import { createSvgElement } from '../svg';
import type { MapRenderStreetModel } from '../types';

/**
 * Builds the non-interactive SVG group for all street labels.
 *
 * @param params Street display data and the single renderer text-color token.
 * @returns Detached group carrying the stable `data-map-layer="streets"` hook.
 */
export function renderStreetsLayer(params: {
  streets: readonly MapRenderStreetModel[];
  textColor: string;
}): SVGGElement {
  const layerElement = createSvgElement('g');
  layerElement.dataset.mapLayer = 'streets';
  layerElement.setAttribute('pointer-events', 'none');

  for (const street of params.streets) {
    const textElement = createSvgElement('text');
    textElement.textContent = street.displayName;
    textElement.setAttribute('x', String(street.centerX));
    textElement.setAttribute('y', String(street.centerY));
    textElement.setAttribute('fill', params.textColor);
    textElement.setAttribute('font-size', String(street.fontSize));
    textElement.setAttribute('font-family', 'ui-sans-serif, system-ui, sans-serif');
    textElement.setAttribute('font-weight', '600');
    textElement.setAttribute('letter-spacing', '0.12rem');
    textElement.setAttribute('text-anchor', 'middle');
    textElement.setAttribute('dominant-baseline', 'middle');
    textElement.setAttribute('aria-hidden', 'true');
    textElement.dataset.mapEntityKind = 'street';
    textElement.dataset.mapEntityId = String(street.id);

    if (street.rotationDegrees !== 0) {
      textElement.setAttribute(
        'transform',
        `rotate(${street.rotationDegrees} ${street.centerX} ${street.centerY})`,
      );
    }

    layerElement.append(textElement);
  }

  return layerElement;
}
